import React from 'react';
import { connect } from 'react-redux';
import { createPopup, closePopup } from '../../../services/popupService';
import {
  ContentWrapper,
  Header,
  PopupContent,
  PopupTextBlock,
  ConfirmButton,
  DismissButton,
  Subtext,
} from '../Popups.styles';
import get from 'lodash/get';
import { isSelectedTicketLiveChat } from 'extractFromState';
import { imageLinkRemovedText } from '../OnTextPasteImageLinkRemoved';
import { CustomInput, DropdownReason, WarningMessage } from './OnTextPastePopup.styles';

class OnTextPastePopup extends React.Component {
  state = {
    textSource: '',
    customTypedTextSource: '',
    confirmButtonActive: false,
  };

  buttonDisabledTimer = null;

  componentWillUnmount() {
    clearTimeout(this.buttonDisabledTimer);
  }

  handleConfirmClick = () => {
    const { onConfirm } = this.props;

    if (onConfirm && typeof onConfirm === 'function') {
      const textSource = this.state.textSource === 'Other' ? this.state.customTypedTextSource : this.state.textSource;
      onConfirm(textSource);
    }

    closePopup();
  };

  handleOptionSelect = (textSource) => {
    const { selectedTicketLiveChat } = this.props;

    let confirmButtonActive;
    if (selectedTicketLiveChat && textSource === 'Other') {
      confirmButtonActive = false;
    } else if (selectedTicketLiveChat) {
      confirmButtonActive = true;
    } else {
      confirmButtonActive = false;
    }

    this.setState({ textSource, confirmButtonActive });

    // if an email ticket, confirm button will get enabled after a 2s timer
    if (!selectedTicketLiveChat) {
      clearTimeout(this.buttonDisabledTimer);
      if (this.props.textSourceOptions[textSource]) {
        this.buttonDisabledTimer = setTimeout(() => {
          this.setState({ confirmButtonActive: true });
        }, 2000);
      }
    }
  };

  handleCustomSourceInputChange = (value) => {
    let confirmButtonActive = true;

    if (!value) {
      confirmButtonActive = false;
    }

    this.setState({ customTypedTextSource: value, confirmButtonActive });
  };

  render() {
    const warningMessage = this.props.textSourceOptions[this.state.textSource];
    const showCustomSourceInput = this.state.textSource === 'Other';

    return (
      <div>
        <ContentWrapper>
          <PopupContent>
            <PopupTextBlock>
              <Header>Please select the source of the copied text</Header>
            </PopupTextBlock>
            <PopupTextBlock>
              <DropdownReason
                value={this.state.textSource}
                onChange={({ target: { value } }) => this.handleOptionSelect(value)}
              >
                <option value="" disabled selected key="first-option">
                  Select a text source
                </option>
                {Object.keys(this.props.textSourceOptions).map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
                <option key="Other" value="Other">
                  Other
                </option>
              </DropdownReason>
              {!!warningMessage && <WarningMessage>{warningMessage}</WarningMessage>}
              {showCustomSourceInput && (
                <CustomInput
                  type="text"
                  value={this.state.customTypedTextSource}
                  onChange={({ target: { value } }) => this.handleCustomSourceInputChange(value)}
                  placeholder="Please type in the text source"
                />
              )}
            </PopupTextBlock>
            <PopupTextBlock>
              <Subtext>{imageLinkRemovedText}</Subtext>
            </PopupTextBlock>
          </PopupContent>
        </ContentWrapper>
        <DismissButton autoFocus onClick={() => closePopup()}>
          CANCEL
        </DismissButton>
        <ConfirmButton disabled={!this.state.confirmButtonActive} onClick={() => this.handleConfirmClick()}>
          CONFIRM AND PASTE
        </ConfirmButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  textSourceOptions: get(state, 'parseConfig.copiedTextSourceOptions', {}),
  selectedTicketLiveChat: isSelectedTicketLiveChat(state),
});

const ConnectedComponent = connect(mapStateToProps)(OnTextPastePopup);

const openOnTextPastePopup = async ({ onConfirm }) =>
  createPopup({
    type: 'OnTextPastePopup',
    content: <ConnectedComponent onConfirm={onConfirm} />,
  });

export default openOnTextPastePopup;
